import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [createOpen, setCreateOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const navRef = useRef(null);

  async function handleLogout() {
    await logout();
    navigate("/admin/login", { replace: true });
  }

  function openCreate() {
    setCreateOpen(true);
  }

  function closeCreate() {
    setCreateOpen(false);
  }

  function toggleNav() {
    setNavOpen((prev) => !prev);
  }

  function closeNav() {
    setNavOpen(false);
  }

  useEffect(() => {
    if (!createOpen) return;

    function onKey(e) {
      if (e.key === "Escape") closeCreate();
    }

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [createOpen]);

  useEffect(() => {
    if (!navOpen) return;

    function onClick(e) {
      if (!navRef.current) return;
      if (!navRef.current.contains(e.target)) closeNav();
    }

    function onKey(e) {
      if (e.key === "Escape") closeNav();
    }

    window.addEventListener("click", onClick);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("click", onClick);
      window.removeEventListener("keydown", onKey);
    };
  }, [navOpen]);

  return (
    <div className="section paper" style={{ paddingBottom: 150 }}>
      <div className="container">
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
          <div>
            <div className="micro muted">
              {user?.email ? `Signed in as ${user.email}` : ""}
            </div>
          </div>

          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <Link className="btn" to="/admin">Dashboard</Link>
            <button className="btn" type="button" onClick={handleLogout}>
              Sign Out
            </button>
          </div>
        </div>

        <div style={{ marginTop: 18 }}>
          <Outlet />
        </div>
      </div>

      <div
        ref={navRef}
        style={{
          position: "fixed",
          right: 16,
          bottom: "calc(16px + env(safe-area-inset-bottom))",
          zIndex: 20,
        }}
      >
        <button
          className="btn primary"
          type="button"
          onClick={toggleNav}
          style={{ padding: "12px 18px", borderRadius: 999 }}
        >
          Menu
        </button>

        {navOpen && (
          <div
            role="menu"
            aria-label="Admin navigation"
            style={{
              position: "absolute",
              right: 0,
              bottom: "calc(100% + 10px)",
              minWidth: 200,
              background: "#fff",
              border: "1px solid rgba(0,0,0,0.12)",
              borderRadius: 14,
              padding: 10,
              boxShadow: "0 12px 30px rgba(0,0,0,0.18)",
              display: "grid",
              gap: 8,
            }}
          >
            <button
              className="btn"
              type="button"
              onClick={() => {
                closeNav();
                openCreate();
              }}
              style={{ background: "#1b1b1b", color: "#fff", borderColor: "#1b1b1b" }}
            >
              Create
            </button>
            <NavLink className="btn" to="/admin" onClick={closeNav}>
              Home
            </NavLink>
            <NavLink className="btn" to="/admin/clients" onClick={closeNav}>
              Clients
            </NavLink>
            <NavLink className="btn" to="/admin/estimates" onClick={closeNav}>
              Estimates
            </NavLink>
            <NavLink className="btn" to="/admin/invoices" onClick={closeNav}>
              Invoices
            </NavLink>
            <NavLink className="btn" to="/admin/settings" onClick={closeNav}>
              Settings
            </NavLink>
          </div>
        )}
      </div>

      {createOpen && (
        <div
          role="dialog"
          aria-modal="true"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeCreate();
          }}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.35)",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            padding: 16,
            zIndex: 30,
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 520,
              background: "#fff",
              borderRadius: 16,
              padding: 16,
              border: "1px solid rgba(0,0,0,0.12)",
              boxShadow: "0 12px 40px rgba(0,0,0,0.2)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center" }}>
              <strong>Create</strong>
              <button className="btn" type="button" onClick={closeCreate}>
                Close
              </button>
            </div>

            <div style={{ display: "grid", gap: 10, marginTop: 12 }}>
              <button
                className="btn primary"
                type="button"
                onClick={() => {
                  closeCreate();
                  navigate("/admin/clients/new");
                }}
              >
                New Client
              </button>
              <button
                className="btn"
                type="button"
                onClick={() => {
                  closeCreate();
                  navigate("/admin/estimates/new");
                }}
              >
                New Estimate
              </button>
              <button
                className="btn"
                type="button"
                onClick={() => {
                  closeCreate();
                  navigate("/admin/invoices/new");
                }}
              >
                New Invoice
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
